module.exports = __webpack_public_path__ + "img/apprehension.2820b07a.png";